import { useHistory } from 'react-router-dom';
import { checkAndRole } from 'network/ApiAxios'

const CheckPermission = async() => {
    const history = useHistory();
    
    const { data } = await checkAndRole()
    if (!data.success) {
        localStorage.clear();
        history.push('/')
        return false
    }
    
    if (localStorage.getItem("user")) {

        let tokenAge = localStorage.getItem("tokenAge");
        tokenAge = Date.parse(tokenAge)
        let dateNow = new Date()
        dateNow = Date.parse(dateNow)
        let dateDiff = (dateNow - tokenAge) / 1000 / 60 / 60;
        if(dateDiff>24){
            localStorage.clear();
            history.push('/')
            return false
        }


        const id = JSON.parse(localStorage.getItem('user'))._id
        const role = JSON.parse(localStorage.getItem("user")).role;
        const pathRole = history.location.pathname.split("/")[1];
        const { data } = await checkAndRole(id,pathRole)
        if (!data.success) {
            localStorage.clear();
            history.push('/')
            return false
        }

        if (role === pathRole) {
            return true
        } else {
            return false
        }


    } else {
        return false
    }
}

export default CheckPermission;